import React from "react";
import { HeartFilled, StarFilled, CheckCircleFilled, AppstoreAddOutlined } from "@ant-design/icons";
import GameDetails from "./GameDetails";

const HorseRaising: React.FC = () => (
    <GameDetails
        game="horseRaising"
        tagColor="purple"
        fallbackInstructionIcon={<AppstoreAddOutlined style={{ color: "#722ed1" }} />}
        instructionIcons={[
            <HeartFilled key="heart" style={{ color: "#e03e2d" }} />,
            <StarFilled key="star" style={{ color: "#f0a500" }} />,
            <CheckCircleFilled key="check" style={{ color: "#52c41a" }} />,
            <AppstoreAddOutlined key="extra-1" style={{ color: "#722ed1" }} />,
            <AppstoreAddOutlined key="extra-2" style={{ color: "#722ed1" }} />,
        ]}
    />
);

export default HorseRaising;
